import { jsx as l } from "react/jsx-runtime";
const d = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M5.577 6.426a.7.7 0 0 1 .957.256L8.068 9.34A10.3 10.3 0 0 1 12 8.576c1.412 0 2.744.274 3.947.77l1.535-2.658a.7.7 0 1 1 1.213.7l-1.492 2.584c2.693 1.59 4.52 4.399 4.797 7.696H2c.276-3.303 2.11-6.116 4.812-7.704l-1.49-2.582a.7.7 0 0 1 .255-.956m11.025 8.392a.834.834 0 0 1 0-1.666.834.834 0 0 1 0 1.666m-9.205 0a.834.834 0 0 1 0-1.666.834.834 0 0 1 0 1.666",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  d as default
};
